import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";

const LoadType = ({
  field: { name },
  form: { setFieldValue },
  fillAddressState,
  ...props
}) => {
  const [loadType, setLoadType] = useState([]);
  const [isloading, setisloading] = useState(false);
  useEffect(() => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/load/type`, readItems: { searchTerm: ' ' } })
      .then((result) => {
        console.log('>>>Load Type>', result.data.data)

        let loadtypeRes = result.data.data

        if (localStorage.getItem('customerNumber') == 549) {
          loadtypeRes.forEach(element => {
            if (element.load_type_name == "Frozen") {
              element.load_type_name = 'Reefer'
            }
          });
          let newLoadType = loadtypeRes.filter((type) => {
            if (type.load_type_name == "Reefer" || type.load_type_name == "Dry") {
              return type
            }
          })

          setLoadType(newLoadType)
        }
        else {
          setLoadType(loadtypeRes)
        }

        setisloading(false)
      })
      .catch((error) => console.log(error));
  }, []);


  let loadTypeOptions = [];
  if (loadType.length > 0) {
    loadType.map((object, index) => {
      let temp = {};
      temp.key = object.load_type_id;
      temp.text = object.load_type_name;
      temp.value = object.load_type_id;
      temp.raw = { ...object };
      return (loadTypeOptions[index] = temp);
    });
  }

  let handleChange = (value, data) => {
    setFieldValue(name, data.value);
  };
  return (
      <Dropdown
        selection
        clearable
        placeholder={props.placeholder}
        loading={isloading ? true : false}
        style={{ width: "100%" }}
        onChange={handleChange}
        options={loadTypeOptions}
        {...props}
      />
  );
};

export default LoadType;
